import React from 'react';
import './Order-page.scss';
import ReadinessForm from './Readiness-form/Readiness-form';
import OrderForm from './Order-form/Order-form';

function OrderPage() {
    const accessToken = localStorage.getItem('access_token');

    return (
        <div className={'order-page-wrapper'}>
            <section className={'section'}>
                <h2 className={'section-title'}>Readiness Form</h2>
                <ReadinessForm accessToken={accessToken} />
            </section>

            <hr className={'section-divider'} />

            <section className={'section'}>
                <h2 className={'section-title'}>Order Form</h2>
                <OrderForm accessToken={accessToken} />
            </section>
        </div>
    );
}

export default OrderPage;
